
    import Vue from "vue";
    import Component from "vue-class-component";
    import SignInForm from "@/components/SignInForm.vue";
    import { User } from "@/model/User";

    // https://vuejs.org/v2/guide/typescript.html

    @Component({
        components: { SignInForm }
    })
    export default class SignIn extends Vue {

        onAuthenticated() {
            const user = this.$store.state.signedInUser as User;
            if(user.isSupplier) this.$router.push("/supplierZone/");
            else if(user.isBuyer) this.$router.push("/buyerZone/supplierModuleMatrix/");
            else if(user.isCqmsOrSuperAdmin) this.$router.push("/supplierModuleMatrix/");
            else  this.$router.push("/messages/");
        }

    }
